/* Randomized, no-repeat rotation for collection-backed featured product grids. */
(function () {
  function shuffle(items) {
    var shuffled = items.slice();
    for (var i = shuffled.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var item = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = item;
    }
    return shuffled;
  }

  function init(root) {
    if (root.hasAttribute('data-featured-products-initialized')) return;
    root.setAttribute('data-featured-products-initialized', 'true');

    var candidates = Array.from(root.querySelectorAll('[data-featured-product]'));
    var requestedCount = parseInt(root.getAttribute('data-display-count'), 10) || 1;
    var displayCount = Math.min(requestedCount, candidates.length);
    if (!displayCount) return;

    var ids = candidates.map(function (candidate) { return candidate.getAttribute('data-product-id'); });
    var storageKey = 'dyoFeaturedRotation:' + (root.getAttribute('data-section-id') || 'section') + ':' +
      (root.getAttribute('data-rotation-key') || 'products');
    var poolKey = ids.slice().sort().join(',');
    var state = {};
    try { state = JSON.parse(localStorage.getItem(storageKey)) || {}; } catch (err) {}

    var previous = state.pool === poolKey && Array.isArray(state.previous) ? state.previous : [];
    var remaining = state.pool === poolKey && Array.isArray(state.remaining) ? state.remaining : shuffle(ids);
    remaining = remaining.filter(function (id, index) {
      return ids.indexOf(id) !== -1 && remaining.indexOf(id) === index;
    });

    var selected = [];
    var nextRemaining = [];
    remaining.forEach(function (id) {
      if (selected.length < displayCount && previous.indexOf(id) === -1) selected.push(id);
      else nextRemaining.push(id);
    });

    if (selected.length < displayCount) {
      var newCycle = shuffle(ids.filter(function (id) {
        return previous.indexOf(id) === -1 && selected.indexOf(id) === -1;
      }));
      while (selected.length < displayCount && newCycle.length) selected.push(newCycle.shift());
      nextRemaining = newCycle;
    }

    if (selected.length < displayCount) {
      shuffle(ids).forEach(function (id) {
        if (selected.length < displayCount && selected.indexOf(id) === -1) selected.push(id);
      });
    }

    candidates.forEach(function (candidate) {
      candidate.hidden = selected.indexOf(candidate.getAttribute('data-product-id')) === -1;
    });
    selected.forEach(function (id) {
      var candidate = root.querySelector('[data-featured-product][data-product-id="' + id + '"]');
      if (candidate) root.appendChild(candidate);
    });

    try {
      localStorage.setItem(storageKey, JSON.stringify({ pool: poolKey, previous: selected, remaining: nextRemaining }));
    } catch (err) {}
  }

  document.querySelectorAll('[data-featured-products]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-featured-products]').forEach(init);
  });
})();
